module.exports = __webpack_public_path__ + "static/cloud_services-839daaddeb0ce8b28f0c2debc24311f7.svg";